// import log from 'loglevel'

const state = {
  snackbar: false,
  timeout: 5000,
  text: ''
}

// getters
const getters = {
  snackbar: state => state.snackbar,
  snackbarTimeout: state => state.timeout,
  snackbarText: state => state.text
}

// mutations
const mutations = {
  SET_SNACKBAR (state, value) { state.snackbar = value },
  SET_SNACKBAR_TEXT (state, text) { state.text = text }
}

// actions
const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}
